// Component: SurveyFullMessage
// Purpose: Message displayed when a survey has reached its maximum number of responses

import React from 'react';
import { AlertCircle } from 'lucide-react';

export const SurveyFullMessage = ({ 
  campaign, 
  themes, 
  getTextStyle, 
  getSubtextStyle 
}) => {
  // Only show if survey is full
  if (campaign?.surveyFull !== true) return null;

  return (
    <div className={`mt-8 p-6 rounded-lg ${
      campaign?.theme && campaign.theme !== 'custom'
        ? `${themes[campaign.theme].border} bg-black/20` 
        : campaign?.theme === 'custom'
          ? 'border-white/20 bg-black/20'
          : 'border border-amber-200 bg-amber-50'
    }`}>
      <div className="flex items-start">
        <div className={`mr-3 flex-shrink-0 ${
          campaign?.theme && campaign.theme !== 'custom'
            ? themes[campaign.theme].text 
            : campaign?.theme === 'custom'
              ? 'text-white'
              : 'text-amber-500'
        }`} style={campaign?.theme === 'custom' ? getTextStyle() : {}}>
          <AlertCircle className="h-6 w-6" />
        </div>
        <div>
          <h3 className={`text-lg font-medium ${
            campaign?.theme && campaign.theme !== 'custom'
              ? themes[campaign.theme].text 
            : campaign?.theme === 'custom'
              ? 'text-white'
              : 'text-amber-800'
          }`} style={campaign?.theme === 'custom' ? getTextStyle() : {}}>
            Survey is currently full
          </h3>
          <div className={`mt-2 ${
            campaign?.theme && campaign.theme !== 'custom'
              ? themes[campaign.theme].subtext 
            : campaign?.theme === 'custom'
              ? 'text-white/80'
              : 'text-amber-700'
          }`} style={campaign?.theme === 'custom' ? getSubtextStyle() : {}}>
            <p>Thank you for your interest in this campaign. We have reached our maximum number of responses at this time.</p>
            <p className="mt-2">Please check back later or contact the campaign organizer for more information.</p>
          </div>
        </div>
      </div>
    </div>
  );
};


